<div class="dialog-header">
    <h2 mat-dialog-title>Goal Seek Returns</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="form" class="goal-seek-form">
        <table class="target-table">
            <thead>
            <tr>
                <th></th>
                <th></th>
                <th>
                    <div class="active-header">
                        Active
                        <button mat-icon-button type="button" [matTooltip]="activeTooltip" matTooltipPosition="above">
                            <mat-icon>info_outline</mat-icon>
                        </button>
                    </div>
                </th>
                @if (data.hasDeal) {
                    <th class="deal-setting-header">Deal Settings</th>
                }
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>TVPI</td>
                <td>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="value-field">
                        <input matInput formControlName="tvpi" type="text" inputmode="decimal" placeholder="e.g. 1.30">
                        <span matTextSuffix>x</span>
                    </mat-form-field>
                </td>
                <td class="checkbox-cell">
                    <mat-checkbox
                        formControlName="tvpiActive"
                        (change)="onTvpiOrIrrActiveChange($event.checked)">
                    </mat-checkbox>
                </td>
                @if (data.hasDeal) {
                    <td class="deal-setting-cell">{{ data.dealGoalSeekTvpi | decimalFormat:'multiple' }}</td>
                }
            </tr>
            <tr>
                <td>IRR (%)</td>
                <td>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="value-field">
                        <input matInput formControlName="irr" type="text" inputmode="decimal" placeholder="e.g. 15.00">
                        <span matTextSuffix>%</span>
                    </mat-form-field>
                </td>
                <td class="checkbox-cell">
                    <mat-checkbox
                        formControlName="irrActive"
                        (change)="onTvpiOrIrrActiveChange($event.checked)">
                    </mat-checkbox>
                </td>
                @if (data.hasDeal) {
                    <td class="deal-setting-cell">{{ data.dealGoalSeekIrr | decimalFormat:'percent' }}</td>
                }
            </tr>
            <tr>
                <td class="no-wrap">Discount to NAV (%)</td>
                <td>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="value-field">
                        <input matInput formControlName="discount" type="text" inputmode="decimal" placeholder="e.g. 10.00">
                        <span matTextSuffix>%</span>
                    </mat-form-field>
                </td>
                <td class="checkbox-cell">
                    <mat-checkbox
                        formControlName="discountActive"
                        (change)="onDiscountActiveChange($event.checked)">
                    </mat-checkbox>
                </td>
                @if (data.hasDeal) {
                    <td class="deal-setting-cell">{{ data.dealGoalSeekDiscount | decimalFormat:'percent' }}</td>
                }
            </tr>
            </tbody>
        </table>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
    @let isSaving = (goalSeekLoading$ | async) ?? false;
    <div class="dialog-actions-left">
        @if (data.hasDeal) {
            <button mat-stroked-button type="button" (click)="resetToDealDefault()">Reset to Deal Default</button>
        }
    </div>
    <div class="dialog-actions-right">
        <button mat-flat-button color="primary" type="button" (click)="goalSeek()" [disabled]="isSaving || isNoTargetActive || hasActiveTargetWithoutValue">
            @if (isSaving) {
                <mat-spinner diameter="18"></mat-spinner>
            } @else {
                Goal Seek
            }
        </button>
    </div>
</mat-dialog-actions>
